"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarcodeNonComplianceType = exports.NonComplianceIssueType = exports.NonComplianceEmailType = void 0;
var NonComplianceEmailType;
(function (NonComplianceEmailType) {
    NonComplianceEmailType["SELLER"] = "SELLER";
    NonComplianceEmailType["WAREHOUSE_REPORTING"] = "WAREHOUSE_REPORTING";
    NonComplianceEmailType["WAREHOUSE_OTHER"] = "WAREHOUSE_OTHER";
    NonComplianceEmailType["MISSING_BOXES"] = "MISSING_BOXES";
    NonComplianceEmailType["SELF_SERVE_DAMAGE"] = "SELF_SERVE_DAMAGE";
})(NonComplianceEmailType = exports.NonComplianceEmailType || (exports.NonComplianceEmailType = {}));
var NonComplianceIssueType;
(function (NonComplianceIssueType) {
    NonComplianceIssueType["UNKNOWN_BARCODE"] = "Unknown Barcode";
    NonComplianceIssueType["MISSING_BARCODE"] = "Missing Barcode";
})(NonComplianceIssueType = exports.NonComplianceIssueType || (exports.NonComplianceIssueType = {}));
var BarcodeNonComplianceType;
(function (BarcodeNonComplianceType) {
    BarcodeNonComplianceType["UNKNOWN"] = "unknown";
    BarcodeNonComplianceType["MISSING"] = "missing";
})(BarcodeNonComplianceType = exports.BarcodeNonComplianceType || (exports.BarcodeNonComplianceType = {}));
//# sourceMappingURL=NonComplianceEmailData.js.map